import { Flex, Tag, TagLeftIcon } from "@chakra-ui/react";
import { RiCheckFill } from "react-icons/ri";
import { isNullOrUndefined } from "src/services/predicates";
import * as AF from "src/types/formTemplate";

type Props = { question: AF.V3.Question };

export const RequirementTag: React.FC<Props> = ({ question }) => {
  if (isNullOrUndefined(question.requirement)) {
    return null;
  }

  return (
    <Flex direction="row">
      <Tag size="sm">
        <TagLeftIcon aria-hidden={true} as={RiCheckFill} />
        {question.requirement}
      </Tag>
    </Flex>
  );
};

export function hasRequirementTag(question: AF.V3.Question): boolean {
  return RequirementTag({ question }) !== null;
}
